import { createContext, lazy, memo, useContext } from 'react';
import { FCC } from '../../../utils/react';
import { DiscoveryTopCategoryItem } from '../types';

export type DiscoveryGlobalContextProps = {
  topCategoryItems: DiscoveryTopCategoryItem[];
};

export const DiscoveryGlobalContext =
  createContext<DiscoveryGlobalContextProps>(null as any);

export const useDiscoveryGlobalContext = () =>
  useContext(DiscoveryGlobalContext);

const DefaultDiscoveryGlobalProvider = lazy(
  () => import('./DefaultDiscoveryGlobalProvider'),
);

export const DiscoveryGlobalProvider: FCC = memo(({ children }) => {
  return (
    <DefaultDiscoveryGlobalProvider>{children}</DefaultDiscoveryGlobalProvider>
  );
});
